import {
  Grid,
  TextField,
  MenuItem,
  Box,
  Typography,
  IconButton,
  Tooltip,
  Autocomplete,
} from "@mui/material";
import { Card, Col, Row, Button } from "react-bootstrap";
import React, { useState, useContext, useEffect } from "react";
import PsContext from "../../context";
import {
  _LIST_STAFFS,
  _LIST_TASK_CATEGORIES,
  _LIST_TASK_LOG,
  _LIST_TASK_PRIORITIES,
  _LIST_TASKS,
} from "../../models/task";
import { Dialog, List, SwipeAction, Toast } from "antd-mobile";
import { momentDate, MuiModalWindow } from "../../utils";
import AddTask from "./addTask";
import moment from "moment";
import CommentIcon from "@mui/icons-material/Comment";
import HistoryIcon from "@mui/icons-material/History";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import WidgetsIcon from "@mui/icons-material/Widgets";
// import DashboardIcon from "@mui/icons-material/Dashboard";
import AddTaskIcon from "@mui/icons-material/AddTask";
import TaskResponse from "./taskResponse";
import ActivityLog from "./activityLog";
import EditTask from "./editTask";

const ViewTasks = (props) => {
  const context = useContext(PsContext);

  // Sample state for managing selections

  const [selTaskStatus, setSelTaskStatus] = useState(null);
  const [selStaff, setSelStaff] = useState(null);
  const [selPriority, setSelPriority] = useState(null);
  const [selCategory, setSelCategory] = useState(null);
  const [staffs, setStaffs] = useState([]);
  const [priorities, setPriorities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [tasksLog, setTasksLog] = useState([]);
  const [selTask, setSelTask] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [showResponseModal, setShowResponseModal] = useState(false);

  useEffect(() => {
    _LIST_STAFFS().then((res) => res.data && setStaffs(res.data));

    _LIST_TASK_PRIORITIES().then((res) => res.data && setPriorities(res.data));

    _LIST_TASK_CATEGORIES().then((res) => res.data && setCategories(res.data));

    if (!context.allowedAccess("mob_allow_task_management", "action_create")) {
      handleSubmit();
    }
  }, []);

  const handleSubmit = () => {
    if (
      context.allowedAccess("mob_allow_task_management", "action_create") &&
      !selStaff
    ) {
      Toast.show({
        icon: "fail",
        content: "Please select staff.",
      });
      return;
    }
    setTasks([]);
    const taskData = {
      task_status: selTaskStatus ? selTaskStatus : 0,
      staff_uuid: context.allowedAccess(
        "mob_allow_task_management",
        "action_create"
      )
        ? selStaff
        : context.user.uuid,
      category_id: selCategory ? selCategory : 0,
      priority_id: selPriority ? selPriority : 0,
    };
    _LIST_TASKS(taskData)
      .then((res) => {
        setTasks(res.data);

        if (res.data.length == 0) {
          Toast.show({
            icon: "fail",
            content: res.message ? res.message : "No Data",
          });
        }
      })
      .catch((error) => {
        console.error("Error listing tasks:", error);
        Toast.show({
          icon: "fail",
          content: "No Data.",
        });
      });
  };

  const handleReset = () => {
    setSelTaskStatus(null);
    setSelStaff(null);
    setSelPriority(null);
    setSelCategory(null);
  };

  const handleResponse = (task) => {
    setSelTask(task);
    setShowResponseModal(true);
  };

  const handleResponseHistory = (task_id) => {
    setTasksLog([]);
    const s = {
      task_id: task_id,
    };
    _LIST_TASK_LOG(s)
      .then((res) => {
        setTasksLog(res.data);
        setShowActivityModal(true);
      })
      .catch((error) => {
        console.error("Error listing tasks:", error);
        Toast.show({
          icon: "fail",
          content: "Error listing task.",
        });
      });
  };
  const getStatusColor = (status) => {
    switch (status) {
      case "completed":
        return "#4caf50"; // Green for completed
      case "processing":
        return "#2196f3"; // Blue for processing
      case "overdue":
        return "#f44336"; // Red for overdue
      case "not_yet_started":
        return "#ff9800"; // Orange for not yet started
      default:
        return "#9e9e9e"; // Gray for undefined statuses
    }
  };
  const sortTasks = (order) => {
    const sortedTasks = [...tasks].sort((a, b) => {
      const dateA = moment(a.date_to_complete); // or the date you want to sort by
      const dateB = moment(b.date_to_complete);

      return order === "asc" ? dateA - dateB : dateB - dateA;
    });
    setTasks(sortedTasks);
  };

  const handleEdit = (task) => {
    setSelTask(task);
    setShowEditModal(true);
  };
  const renderTask = (task) => {
    // Calculate the number of days left
    const daysLeft = moment(task.date_to_complete).diff(
      moment(task.created_on),
      "days"
    );

    return (
      <Box
        key={task.id}
        mb={2}
        p={2}
        border="1px solid #ccc"
        borderRadius="8px"
      >
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h6" component="span">
              {task.task_title}
            </Typography>
            {context.allowedAccess(
              "mob_allow_task_management",
              "action_create"
            ) &&
              task.task_status != "completed" && (
                <IconButton
                  onClick={() => {
                    handleEdit(task);
                  }}
                  size="small"
                >
                  <EditIcon />
                </IconButton>
              )}
          </Grid>
        </Grid>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography variant="body2" color="textSecondary">
              {`${daysLeft} days left | `}
              {moment(task.created_on).format("DD-MM-YYYY")} →
              {moment(task.date_to_complete).format("DD-MM-YYYY")}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              variant="caption"
              style={{
                color: "white",
                backgroundColor: task.color_code,
                padding: "4px 8px",
                borderRadius: "4px",
              }}
            >
              {task.priority_level}
            </Typography>
          </Grid>
        </Grid>
        <Typography variant="body1" mt={1}>
          {task.task_description}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {`${task.assigned_by_name} → ${task.employee_name}(${task.staff_role_name})`}
        </Typography>
        <Grid container justifyContent="space-between" mt={2}>
          <Grid item>
            <Button
              onClick={() => handleResponse(task)} // Your response handler
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <IconButton color="primary">
                <CommentIcon />
              </IconButton>
              <Typography variant="caption" align="center">
                Update Log
              </Typography>
            </Button>
          </Grid>

          <Grid item>
            <Button
              onClick={() => handleResponseHistory(task.id)} // Your response history handler
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <IconButton color="secondary">
                <HistoryIcon />
              </IconButton>
              <Typography variant="caption" align="center">
                Activity History
              </Typography>
            </Button>
          </Grid>
        </Grid>

        <Box
          mt={2}
          borderTop="1px solid #ccc" // Top border line
          pt={1} // Padding top to create some space between the content and the line
          textAlign="center" // Center the status text
        >
          <Typography
            variant="caption"
            style={{
              color: "white",
              backgroundColor: getStatusColor(task.task_status),
              padding: "4px 8px",
              borderRadius: "4px",
              display: "inline-block", // Allows the background color to fill the text area
              width: "100%", // Make the status fill the full width below the border line
            }}
          >
            {task.task_status.replace(/_/g, " ")}
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <>
      <Card>
        <Card.Header className="card-header-bg fw-bold text-uppercase">
          {context.allowedAccess("mob_allow_task_management", "action_create")
            ? "VIEW TASKS"
            : "MY TASKS"}

          {context.allowedAccess(
            "mob_allow_task_management",
            "action_create"
          ) && (
            <span className="float-end p-0 m-0">
              <IconButton
                color="primary"
                onClick={props.goBackToDashboard}
                aria-label="go-to-dashboard"
                className="p-0 m-0 me-2"
              >
                <WidgetsIcon />
              </IconButton>
              <IconButton
                color="primary"
                onClick={() => setShowModal(true)}
                aria-label="add-task"
                className="p-0 m-0"
              >
                <AddIcon />
              </IconButton>
            </span>
          )}
        </Card.Header>

        {context.allowedAccess(
          "mob_allow_task_management",
          "action_create"
        ) && (
          <Card.Body className="mt-2">
            <Grid container spacing={2}>
              <Grid item xs={6} md={4}>
                <TextField
                  select
                  fullWidth
                  label="Task Status"
                  size="small"
                  value={selTaskStatus}
                  onChange={(e) => setSelTaskStatus(e.target.value)}
                >
                  <MenuItem value={null}>All</MenuItem>
                  <MenuItem value={"pending"}>Pending</MenuItem>
                  <MenuItem value={"completed"}>Completed</MenuItem>
                  <MenuItem value={"processing"}>Processing</MenuItem>
                  <MenuItem value={"overdue"}>Overdue</MenuItem>
                  <MenuItem value={"not_yet_started"}>Not Yet Started</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={6} md={4}>
                <Autocomplete
                  options={staffs}
                  size="small"
                  getOptionLabel={(option) => option.emp_name}
                  value={
                    staffs.find((staff) => staff.uuid === selStaff) || null
                  } // Find the staff object by uuid
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setSelStaff(newValue.uuid); // Set selStaff to the uuid
                    } else {
                      setSelStaff(null); // Handle the case when no staff is selected
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Staff" fullWidth required />
                  )}
                />
              </Grid>

              <Grid item xs={6} md={4}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Priority"
                  value={selPriority}
                  onChange={(e) => setSelPriority(e.target.value)}
                >
                  {priorities.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.priority_level}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={6} md={4}>
                <TextField
                  select
                  fullWidth
                  label="Category"
                  size="small"
                  value={selCategory}
                  onChange={(e) => setSelCategory(e.target.value)}
                >
                  {categories.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.category_name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={2} alignItems="flex-end">
              <Grid item xs={3} md={3}>
                <Button
                  variant="contained"
                  className="bg-theme text-white"
                  fullWidth
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </Grid>

              <Grid item xs={3} md={3}>
                <Button
                  variant="outlined"
                  className="bg-theme text-white"
                  fullWidth
                  onClick={handleReset}
                >
                  Reset
                </Button>
              </Grid>
              <Grid item xs={6} md={3}>
                <Button
                  variant="outlined"
                  className="bg-theme text-white"
                  fullWidth
                  onClick={() => {
                    const newOrder = sortOrder === "asc" ? "desc" : "asc";
                    setSortOrder(newOrder);
                    sortTasks(newOrder);
                  }}
                >
                  Sort by Date {sortOrder === "asc" ? "↑" : "↓"}
                </Button>
              </Grid>
            </Grid>
          </Card.Body>
        )}
        {context.allowedAccess("mob_allow_task_management", "action_list") &&
          tasks &&
          tasks.length > 0 && (
            <Card.Body>{tasks.map((task) => renderTask(task))}</Card.Body>
          )}
      </Card>
      <MuiModalWindow
        open={showModal}
        onClose={(e) => setShowModal(false)}
        title="Add Task"
      >
        <AddTask
          staffs={staffs}
          priorities={priorities}
          categories={categories}
          onSuccess={(e) => {
            setShowModal(false);
          }}
        />
      </MuiModalWindow>

      <MuiModalWindow
        open={showEditModal}
        onClose={(e) => setShowEditModal(false)}
        title="Edit Task"
      >
        <EditTask
          dataSource={selTask}
          staffs={staffs}
          priorities={priorities}
          categories={categories}
          onSuccess={(e) => {
            setSelTask(null);
            setShowEditModal(false);
            handleSubmit();
          }}
        />
      </MuiModalWindow>

      <MuiModalWindow
        open={showActivityModal}
        onClose={(e) => setShowActivityModal(false)}
        title="Activity log"
      >
        {tasksLog && tasksLog.length > 0 ? (
          <ActivityLog
            dataSource={tasksLog}
            onSuccess={(e) => {
              setShowActivityModal(false);
            }}
          />
        ) : (
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ fontStyle: "italic" }}
          >
            No updates or actions have been recorded for this task yet.
          </Typography>
        )}
      </MuiModalWindow>

      <MuiModalWindow
        open={showResponseModal}
        onClose={(e) => setShowResponseModal(false)}
        title="Update activity"
      >
        <TaskResponse
          dataSource={selTask}
          onSuccess={(e) => {
            setSelTask(null);
            setShowResponseModal(false);
            handleSubmit();
          }}
        />
      </MuiModalWindow>
    </>
  );
};

export default ViewTasks;
